import PropTypes from 'prop-types';
import React from 'react';
import {LinkButton} from '../utils/Styled/buttons';
import {Row, Col} from 'react-bootstrap';
import Style from './style.scss';
import C_A from '../../constants/analytics';
import styled from 'styled-components';
import Cx from 'classnames';

const StyledLi = styled.li`
    color:${props => props.theme.brandColor};
    button:after{ {
        color:${props => props.theme.textColor};
      }
`;

const StyledSpan = styled.span`
    .hasNext:before{ {
        color:${props => props.theme.textColor};
      }
    
`;
const StyledRow = styled(Row)`
    border-bottom:solid 1px ${props => props.theme.borderColor};
`;
const StyledLastItem=styled.span`
        color:${props => props.theme.textColor};
`;

const BlockEllipsis = styled.ul`
	  &:after {
        background-color: ${props => props.theme.pageBackground};
      }
 `;
const ScBreadcrumbs = props => {
    let count = props.currentBranches.length - 2;
    let homeBranch = props.currentBranches[0];
    const home = <StyledSpan className={Style.home}><LinkButton bsStyle='link' title={homeBranch.name} className={Style.hasNext}  onClick={(() => {
                props.reportAnalytics([C_A.TOOLBOX_ITEMS_BREADCRUMBS, C_A.CLICK, homeBranch.type]);
                props.updateBranch(homeBranch);
            })}>{props.intlObject['ssp.toolbox.Home']}
            </LinkButton></StyledSpan>;


    const path = props.currentBranches.slice(1, props.currentBranches.length).map((item, index) => {
        return index !== count ? <StyledLi key={index} className={Style.hasNext}><LinkButton bsStyle='link' title={item.name}   onClick={(() => {
                                  props.reportAnalytics([C_A.TOOLBOX_ITEMS_BREADCRUMBS, C_A.CLICK, item.type]);
                                  props.updateBranch(item);
                              })}>{item.name}
                              </LinkButton></StyledLi>
            : <li key={index}><StyledLastItem  className={Style.lastItem}>{item.name}</StyledLastItem></li>;
    });

    return <StyledRow className={Style.pathWrapper}>
        <Col lg={12} md={12} className={Cx('noSidePadding',Style.flexBox)} >{home}<BlockEllipsis className={Style.breadCrumb}>{path.reverse()}</BlockEllipsis></Col>

    </StyledRow>;
};

ScBreadcrumbs.propTypes = {
    currentBranches: PropTypes.array.isRequired,
    reportAnalytics:PropTypes.func.isRequired,
    updateBranch: PropTypes.func.isRequired,
    intlObject: PropTypes.object.isRequired
};

export default ScBreadcrumbs;



// WEBPACK FOOTER //
// ./components/ServiceCatalog/scBreadcrumbs.js